import { cloneDeep,isNil, noop, hasIn, isEmpty } from 'lodash';

export const DocumentVersion = Object.freeze({
    V2: 'v2',
});

export default {
    data(){
        return {
            globalConfig: null
        }
    },

    methods:{
        setReactiveProperty(obj, prop, value) {
            isNil(obj[prop]) || obj[prop] === 'undefined' ? obj[prop] = value : noop();
        },

        replaceOldProperty(obj, oldProp, newProp) {
            obj[newProp] = cloneDeep(obj[oldProp]);
            delete obj[oldProp]
        },

        processHeader(header){
            this.setReactiveProperty(header.style, 'backgroundPosition', 'center center');
            this.setReactiveProperty(header.style, 'backgroundOpacity', 100);
            this.setReactiveProperty(header.style, 'backgroundSize', {
                name: 'Fill Container',
                value: 'cover',
            });
            this.setReactiveProperty(header.style, 'backgroundRepeat', false);
            this.setReactiveProperty(header.style, 'computedBackgroundImage', null);
        },

        processFooter(footer) {
            // Required to update older footers with the new values for footer settings probably remove this down the road.
            this.setReactiveProperty(footer.style, 'backgroundPosition', 'center center');
            this.setReactiveProperty(footer.style, 'backgroundOpacity', 100);
            this.setReactiveProperty(footer.style, 'backgroundSize', {
                name: 'Fill Container',
                value: 'cover',
            });
            this.setReactiveProperty(footer.style, 'backgroundRepeat', false);
            this.setReactiveProperty(footer.style, 'computedBackgroundImage', null);
        },

        processSection(section) {
            // Required to update older sections with the new values for section settings probably remove this down the road.
            this.setReactiveProperty(
                section.style,
                'hasSolidBackgroundColor',
                !section.style.hasGradientBackground
            );
            this.setReactiveProperty(section.style, 'backgroundPosition', 'center center');
            this.setReactiveProperty(section.style, 'backgroundOpacity', 100);
            this.setReactiveProperty(section.style, 'backgroundSize', {
                name: 'Fill Container',
                value: 'cover',
            });
            this.setReactiveProperty(section.style, 'backgroundRepeat', false);
            this.setReactiveProperty(section.style, 'computedBackgroundImage', null);
            this.setReactiveProperty(section.style, 'computedBackgroundImageWidth', null);
            this.setReactiveProperty(section.style, 'scaledBackgroundImage', null);
        },

        processQuote(unprocessedQuote){
            const defaultRowStyles = {
                title: {
                    color: {
                        branding: null,
                        enabled: true,
                        type: null,
                        value: '#18AEFF',
                    },
                    fontSize: 16,
                    fontFamily: {
                        key: 'Roboto',
                        value: 'Roboto, Helvetica, Arial, Tahoma, \'Franklin Gothic Medium\', sans-serif',
                    },
                },

                description: {
                    color: {
                        branding: null,
                        enabled: true,
                        type: null,
                        value: '#877D88',
                    },
                    fontSize: 12,
                    fontFamily: {
                        key: 'Roboto',
                        value: 'Roboto, Helvetica, Arial, Tahoma, \'Franklin Gothic Medium\', sans-serif',
                    },
                },

                calculation: {
                    color: {
                        branding: null,
                        enabled: true,
                        type: null,
                        value: '#382153',
                    },
                    fontSize: 14,
                    fontFamily: {
                        key: 'Roboto',
                        value: 'Roboto, Helvetica, Arial, Tahoma, \'Franklin Gothic Medium\', sans-serif',
                    },
                },
            };
            
            hasIn(unprocessedQuote.style, 'primaryCellStyles')
                ? this.replaceOldProperty(
                      unprocessedQuote.style,
                      'primaryCellStyles',
                      'primaryRowStyles'
                  )
                : noop();

            hasIn(unprocessedQuote.style, 'secondaryCellStyles')
                ? this.replaceOldProperty(
                      unprocessedQuote.style,
                      'secondaryCellStyles',
                      'secondaryRowStyles'
                  )
                : noop();

            hasIn(unprocessedQuote.style, 'scaledPrimaryCellFontSize')
                ? delete unprocessedQuote.style.scaledPrimaryCellFontSize
                : noop();

            hasIn(unprocessedQuote.style, 'scaledSecondaryCellFontSize')
                ? delete unprocessedQuote.style.scaledSecondaryCellFontSize
                : noop();

            this.setReactiveProperty(
                unprocessedQuote.style.primaryRowStyles,
                'title',
                defaultRowStyles.title
            );

            this.setReactiveProperty(
                unprocessedQuote.style.primaryRowStyles,
                'description',
                defaultRowStyles.description
            );
            this.setReactiveProperty(
                unprocessedQuote.style.primaryRowStyles,
                'calculation',
                defaultRowStyles.calculation
            );
            this.setReactiveProperty(
                unprocessedQuote.style.secondaryRowStyles,
                'title',
                defaultRowStyles.title
            );
            this.setReactiveProperty(
                unprocessedQuote.style.secondaryRowStyles,
                'description',
                defaultRowStyles.description
            );
            this.setReactiveProperty(
                unprocessedQuote.style.secondaryRowStyles,
                'calculation',
                defaultRowStyles.calculation
            );
            this.setReactiveProperty(unprocessedQuote.style, 'scaledPrimaryTitleFontSize', null);
            this.setReactiveProperty(
                unprocessedQuote.style,
                'scaledPrimaryDescriptionFontSize',
                null
            );
            this.setReactiveProperty(
                unprocessedQuote.style,
                'scaledPrimaryCalculationFontSize',
                null
            );
            this.setReactiveProperty(unprocessedQuote.style, 'scaledSecondaryTitleFontSize', null);
            this.setReactiveProperty(
                unprocessedQuote.style,
                'scaledSecondaryDescriptionFontSize',
                null
            );
            this.setReactiveProperty(
                unprocessedQuote.style,
                'scaledSecondaryCalculationFontSize',
                null
            );

            this.setReactiveProperty(unprocessedQuote.content, 'quoteView', {
                showUpfront: true,
                showMonthly: true,
                showQuarterly: true,
                showSemiAnnual: true,
                showAnnual: true,
                showTax: true,
                showDiscount: true,
                showInitialPayment: true,
                showTotal: true,
            });

            this.setReactiveProperty(unprocessedQuote.content, 'solutionsView', {
                showName: true,
                showDescription: true,
                showPrice: true,
                showQuantity: true,
                showTerm: true,
                showDiscount: true,
                showSubtotal: true,
                showProductImage: true,
            });

            unprocessedQuote.content.solutions.forEach((solution) => {
                this.setReactiveProperty(solution, 'term', 1);
                this.setReactiveProperty(solution, 'viewConfig', {
                    showName: true,
                    showDescription: true,
                    showPrice: true,
                    showQuantity: true,
                    showTerm: true,
                    showDiscount: true,
                    showSubtotal: true,
                    showProductImage: true,
                });
            });

            this.setReactiveProperty(unprocessedQuote.style.footerStyles, 'borders', []);
            this.setReactiveProperty(
                unprocessedQuote.style.footerStyles,
                'borderThickness',
                'thick'
            );
            this.setReactiveProperty(unprocessedQuote.style.footerStyles, 'backgroundColor', {
                branding: null,
                enabled: true,
                type: null,
                value: '#382153',
            });
            this.setReactiveProperty(unprocessedQuote.style.footerStyles, 'borderColor', {
                branding: null,
                enabled: true,
                type: null,
                value: '#2ADA2B',
            });
            this.setReactiveProperty(unprocessedQuote.style, 'scaledFooterBorderThickness', null);
            this.setReactiveProperty(unprocessedQuote.style, 'scaledFooterFontSize', null);
        },

        processCheckbox(unprocessedCheckbox){
            const htmlTagRegex = /<[^>]*>/g;
            this.setReactiveProperty(unprocessedCheckbox.content, 'hasLabel', false);
            this.setReactiveProperty(
                unprocessedCheckbox.content,
                'message',
                cloneDeep(unprocessedCheckbox.content.labelText)
            );

            if (htmlTagRegex.test(unprocessedCheckbox.content.labelText)) {
                unprocessedCheckbox.content.labelText = 'Enter Label';
            }

            if (isEmpty(unprocessedCheckbox.style)) {
                unprocessedCheckbox.style = {
                    label: cloneDeep(this.globalConfig.classes.text),
                    scaledLabelFontSize: null,
                };
            }

        },

        processElement(element, isFreeForm = false){
           this.setReactiveProperty(element, 'isFreeForm', isFreeForm);
            switch(element.type){
                case 'quote':
                    this.processQuote(element);
                    break
                case 'checkbox':
                    this.processCheckbox(element);
                break
                default:
                    break
            }
        },

        updateDocumentConfig(config){
            const version = config.version || null;

            
            if(version){
                return config
            };
            
            this.globalConfig = config.global;
            const header = config.header;
            const footer = config.footer;
            const pages = config.pages;
                        
            if (header) {
                this.processHeader(header);
            }
            
            if (footer) {
                this.processFooter(footer);
            }
            
            let structuredPages = [];
            let freeformPages = [];

            pages.forEach((page) => {
                if (page.sections) {
                    structuredPages.push(page);

                    if (page.header) {
                        this.processHeader(page.header);
                    }

                    if (page.footer) {
                        this.processFooter(page.footer);
                    }
                } else {
                    freeformPages.push(page);
                }
            });

            const sections = structuredPages.flatMap((page) => page.sections);

            const elements = sections.flatMap((section) => {
                return section.columns.flatMap((column) => {
                    return column.elements.flatMap((element) => element);
                });
            });

            const freeformElements = freeformPages.flatMap((page) => {
                return page.elements.flatMap((element) => element);
            });

            sections.forEach((section) => {
                this.processSection(section);
            });

            elements.forEach((element) => {
                this.processElement(element);
            });

            freeformElements.forEach((element) => {
                this.processElement(element, true);
            });

            config.version = DocumentVersion.V2

            return config
            
        }
    }
}